import { defineMessages } from 'react-intl';

/** Settings → AI assistants (design: ai-assistants a1-a4, e1). */
export const aiAssistantsMessages = defineMessages({
  tab: { id: 'app.sml.settings.tab.aiAssistants', defaultMessage: 'AI assistants' },
  subtitle: {
    id: 'app.sml.settings.aiAssistants.subtitle',
    defaultMessage: 'Connect Claude, ChatGPT or another AI assistant to this workspace.',
  },
  heroTitle: {
    id: 'app.sml.settings.aiAssistants.hero.title',
    defaultMessage: 'Run your release from Claude or ChatGPT',
  },
  heroBody: {
    id: 'app.sml.settings.aiAssistants.hero.body',
    defaultMessage:
      'Make reels and release assets, plan and schedule posts, and check what moved. You ask in plain words. Your assistant does the work in MUSIC24.',
  },
  urlLabel: { id: 'app.sml.settings.aiAssistants.url.label', defaultMessage: 'Connector URL' },
  copy: { id: 'app.sml.settings.aiAssistants.url.copy', defaultMessage: 'Copy' },
  copied: { id: 'app.sml.settings.aiAssistants.url.copied', defaultMessage: 'Copied' },
  copyLabel: { id: 'app.sml.settings.aiAssistants.url.copyLabel', defaultMessage: 'Copy the connector URL' },
  claudeStep1: {
    id: 'app.sml.settings.aiAssistants.claude.step1',
    defaultMessage: 'Open the connector settings in Claude.',
  },
  claudeStep2: {
    id: 'app.sml.settings.aiAssistants.claude.step2',
    defaultMessage: 'Add a custom connector and paste the URL.',
  },
  chatgptStep1: {
    id: 'app.sml.settings.aiAssistants.chatgpt.step1',
    defaultMessage: 'Turn on developer mode in the ChatGPT settings.',
  },
  chatgptStep2: {
    id: 'app.sml.settings.aiAssistants.chatgpt.step2',
    defaultMessage: 'Add an app or a connector and paste the URL.',
  },
  otherName: { id: 'app.sml.settings.aiAssistants.other.name', defaultMessage: 'Other MCP clients' },
  otherStep1: {
    id: 'app.sml.settings.aiAssistants.other.step1',
    defaultMessage: 'Add the URL as a remote MCP server.',
  },
  otherStep2: {
    id: 'app.sml.settings.aiAssistants.other.step2',
    defaultMessage: 'The client signs in with OAuth. It needs no API token.',
  },
  approveStep: {
    id: 'app.sml.settings.aiAssistants.approveStep',
    defaultMessage: 'Sign in to MUSIC24 and approve.',
  },
  promise: {
    id: 'app.sml.settings.aiAssistants.promise',
    defaultMessage: 'Works on every plan. MUSIC24 asks you before anything is posted, shared, deleted or uses credits.',
  },
  docsLead: { id: 'app.sml.settings.aiAssistants.docs.lead', defaultMessage: 'Every tool, with examples:' },
  docsLink: { id: 'app.sml.settings.aiAssistants.docs.link', defaultMessage: 'API and MCP docs' },
  apiTabLink: {
    id: 'app.sml.settings.aiAssistants.apiTabLink',
    defaultMessage: 'Connected AI assistants are in <link>AI assistants</link>.',
  },

  connectedTitle: { id: 'app.sml.settings.aiAssistants.connected.title', defaultMessage: 'Connected assistants' },
  connectedDescription: {
    id: 'app.sml.settings.aiAssistants.connected.description',
    defaultMessage: 'The assistants you approved for this workspace. Revoke one to end its access at once.',
  },
  connectedCount: {
    id: 'app.sml.settings.aiAssistants.connected.count',
    defaultMessage: '{count, plural, one {# assistant} other {# assistants}}',
  },
  connectedEmpty: {
    id: 'app.sml.settings.aiAssistants.connected.empty',
    defaultMessage: 'No assistant connected yet',
  },
  connectedEmptyBody: {
    id: 'app.sml.settings.aiAssistants.connected.emptyBody',
    defaultMessage:
      'Add the connector URL to your assistant and approve it. It shows here, and you can revoke it at any time.',
  },
  columnAssistant: { id: 'app.sml.settings.aiAssistants.connected.columnAssistant', defaultMessage: 'Assistant' },
  readWrite: { id: 'app.sml.settings.aiAssistants.connected.readWrite', defaultMessage: 'Read and write' },
  connectedFootnote: {
    id: 'app.sml.settings.aiAssistants.connected.footnote',
    defaultMessage:
      'An assistant keeps access while it renews its tokens. Signing out everywhere does not disconnect it. Revoke it here.',
  },
});
